import { Component, OnInit } from '@angular/core';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { SharedModule } from '../../../../common/shared.module';
import { policyMask } from '../../../../common/constants/masks';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { SwalService } from '../../../../common/services/swal.service';
import { InsuredStepComponent } from '../components/insured-step/insured-step.component';
import { ClaimRequestService } from '../../services/claim.request.service';
import { HealthInsuredService } from '../../services/health.insured.service';
import HealthInsured from '../../../../core/data/models/health.insured.model';
import { ClaimRequestFormStepComponent } from '../components/claim-request-form-step/claim-request-form-step.component';
import { ClaimRequestRateComponent } from '../components/claim-request-rate/claim-request-rate.component';
import { lastValueFrom } from 'rxjs';
import { INSURED_TYPE_CODE } from '../../utils/claimRequestConstants';
import { PlatformsService } from '../../../../core/data/services/platforms.service';

@Component({
    selector: 'app-claim-request-create',
    providers: [HealthInsuredService, ClaimRequestService],
    imports: [
        NgbProgressbarModule,
        InsuredStepComponent,
        ClaimRequestFormStepComponent,
        ClaimRequestRateComponent,
        SharedModule,
    ],
    templateUrl: './claim-request-create.component.html',
    styleUrl: './claim-request-create.component.css'
})
export class ClaimRequestCreateComponent implements OnInit {
  insuredList: HealthInsured[] = [];
  insuredHolder?: HealthInsured | null = null;
  idNumber?: string;

  insuredSelected: HealthInsured | null = null;

  activeStep = 1;
  policyMask = policyMask;
  claimRequestId?: number;

  constructor(
    private location: Location,
    private authService: AuthService,
    private route: ActivatedRoute,
    private swalService: SwalService,
    private healthInsuredService: HealthInsuredService,
  private  platformService: PlatformsService,
  ) {}

  get progressValue() {
    return this.activeStep * 33.33;
  }

  get isIntermediary() {
    return (this.platformService.isIOs() || this.platformService.isEmbeddedApp()) ? false : this.authService?.isIntermediary;
  }

  ngOnInit() {

    if (this.isIntermediary) {
      const clientId = this.route.snapshot.queryParams['client'];

      if (!clientId) {
        this.swalService.error('No se pudo obtener el cliente');
        return;
      }

      this.idNumber = clientId;
    }

    this.getInsuredList();
  }

  async getInsuredList() {
    this.swalService.showLoading();
    const user = this.authService.user;
const idNumberParam = this.route.snapshot.queryParams['client'];
const useTokenBridge = this.platformService.isIOs() || this.platformService.isEmbeddedApp();
let idNumber = '';
if (!useTokenBridge) {
 idNumber = this.idNumber || user?.idTokenClaims?.extension_IdNumber!;
}
 if (useTokenBridge && idNumberParam) {
      idNumber = idNumberParam;
    }

    try {
      const result = await lastValueFrom(
        this.healthInsuredService.getMyHealthInsured(idNumber),
      );

      if (result?.data?.length > 0) {
        this.insuredList = result.data;

        const holder = result?.data?.find(
          (insured) => insured.dependent === INSURED_TYPE_CODE.HOLDER,
        );

        this.insuredHolder = holder;
      }
    } catch (e) {}
    this.swalService.dismiss();
  }

  onFormCompleted(id: number) {
    this.claimRequestId = id;
  }

  nextStep() {
    if (this.activeStep === 1 && !this.insuredSelected) {
      this.swalService.error('Favor seleccionar el asegurado.');
      return;
    }
    if (this.activeStep < 3) {
      this.activeStep += 1;
    }
  }

  onInsuredSelected = (insured: HealthInsured) => {
    this.insuredSelected = insured;
  };

  onBackPressed() {
    if (this.activeStep >= 2) {
      this.activeStep -= 1;
    } else {
      this.location.back();
    }
  }
}
